import { formatDateTime } from "src/shared/Format/dateFormat";

const TableDateTimeFromat = (value) => {
  return (
    <td className="py-2">
      <span>{value === null ? "" : formatDateTime(value)}</span>
    </td>
  );
};
export default TableDateTimeFromat;
